import { gql, useMutation, useLazyQuery, FetchResult } from '@apollo/client';
import React, { createContext } from 'react';

const AuthContext = createContext<AuthContextType>(null!);

export interface AuthContextType {
  sendOtp(phoneNumber: string): Promise<FetchResult<any>>;
  veryfyOtp(otp: string): Promise<FetchResult<any>>;
  setToken(token: string): void;
  getToken(): string | null;
  sendingOtp: boolean;
  verifying: boolean;
}

const INITIATE_MEMBER_LOGIN = gql`
  query InitiateMemberLogin($phoneNumber: String!) {
    initiateMemberLogin(phoneNumber: $phoneNumber) {
      message
    }
  }
`;

const COMPLETE_MEMBER_LOGIN = gql`
  mutation CompleteMemberLogin($otp: String!, $phoneNumber: String!) {
    completeMemberLogin(params: { otp: $otp, phoneNumber: $phoneNumber }) {
      accessToken
    }
  }
`;

const otpNumberKey = 'fsos:auth:phone_number';
export const tokenKey = 'fsos:auth:token';

export const AuthProvider = ({ children }: { children: React.ReactNode }) => {
  const [initiateMemberLogin, { loading: sendingOtp }] = useLazyQuery(
    INITIATE_MEMBER_LOGIN,
    { fetchPolicy: 'no-cache' }
  );
  const [completeMemberLogin, { loading: verifying }] = useMutation(
    COMPLETE_MEMBER_LOGIN,
    {
      onError: (error) => {
        console.log(error);
      }
    }
  );

  const sendOtp: AuthContextType['sendOtp'] = async (phoneNumber) => {
    sessionStorage.setItem(otpNumberKey, phoneNumber);
    return await initiateMemberLogin({
      variables: { phoneNumber }
    });
  };

  const veryfyOtp: AuthContextType['veryfyOtp'] = async (otp) => {
    const phoneNumber = sessionStorage.getItem(otpNumberKey);
    return completeMemberLogin({
      variables: { phoneNumber, otp }
    });
  };

  const getToken = (): string | null => {
    if (window) {
      return localStorage.getItem(tokenKey);
    }
    return null;
  };

  const setToken = (token: string) => {
    localStorage.setItem(tokenKey, token);
  };

  return (
    <AuthContext.Provider
      value={{
        veryfyOtp,
        sendOtp,
        sendingOtp,
        verifying,
        setToken,
        getToken
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
